"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Admin = function Admin() {
  return _react2.default.createElement(
    "g",
    { id: "admin" },
    _react2.default.createElement("path", {
      d: "M91.4745501,462.539695 L299.20955,281.937695 C353.84155,300.281695 415.87555,288.525695 456.61255,252.166695 C500.59555,213.135695 512.34855,154.860695 486.29955,105.310695 L387.85355,190.656695 L319.46355,131.127695 L417.53755,43.6486951 C360.77755,19.8526951 292.75055,30.2866951 248.89255,69.4376951 C207.06355,105.189695 193.57255,158.887695 214.49955,206.396695 L6.80155013,387.298695 C-2.11444987,394.768695 -2.28544987,407.062695 6.41155013,414.725695 C6.51055013,414.846695 6.65555013,414.939695 6.80155013,415.059695 L59.2465501,460.699695 C65.8505501,468.820695 78.7925501,470.742695 88.1475501,465.071695 C89.3605501,464.337695 90.4845501,463.515695 91.4745501,462.539695 Z",
      id: "Shape"
    })
  );
};

exports.default = Admin;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Admin.js
// module id = 2918
// module chunks = 4